export default __webpack_public_path__ + "static/media/CN_Vibez.5120206f.mp3";